import * as formik from 'formik';
import * as yup from 'yup';

import { Form, Modal } from "react-bootstrap";
import { useEffect, useState } from 'react';

import AppButton from '../../../commons/buttons/AppButton';
import AppContainer from '../../../commons/containers/AppContainer';
import AppInput from "../../../commons/inputs/AppInput";
import AppInputV2 from '../../../commons/inputs/AppInputV2';
import AppLinkButton from '../../../commons/buttons/AppLinkButton';
import AppLoading from '../../../commons/AppLoading';
import CustomCard from '../../../commons/cards/Card';
import CustomerAPI from '../CustomerAPI';
import HallAppToast from '../../../commons/HallAppToast';
import axios from 'axios';
import { formatPhone } from '../../../commons/util/HallAppUtil';
import { useMask } from "@react-input/mask";

const service = new CustomerAPI();

function AddManualCustomerModal({ closeShow, show, customer, call }) {

    const [initialValues, setInitialValues] = useState({
        name: '',
        whatsapp: '',
        birthday: '',
        zipcode: '',
        district: '',
        street: '',
        number: '',
        city: '',
        state: '',
        complement: ''
    });

    const [address, setAddress] = useState(false)
    const [zipcode, setZipcode] = useState('');
    const [disabledInputZipcode, setDisabledInputZipcode] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const { Formik } = formik;

    const schema = yup.object().shape({
        name: yup.string().required('Nome do cliente é obrigatório'),
        whatsapp: yup
            .string()
            .required('Whatsapp do cliente é obrigatório')
            .matches(
                /^\(\d{2}\)\d{4,5}-\d{4}$/,
                'Whatsapp deve estar no formato (99)99999-9999'
            ),
        birthday: yup
            .string()
            .matches(
                /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])(\/\d{4})?$/,
                'Data de nascimento deve estar no formato DD/MM ou DD/MM/AAAA'
            )
            .nullable(),
        zipcode: yup.string(),
        district: yup.string(),
        street: yup.string(),
        city: yup.string(),
        state: yup.string(),
        number: yup.string(),
        complement: yup.string(),
    });

    useEffect(() => {
        if (customer && Object.keys(customer).length > 0) {
            if (customer.zipcode) {
                setZipcode(formatCep(customer.zipcode))
            }
            setInitialValues({
                name: customer.name,
                birthday: customer.birthday,
                whatsapp: formatPhone(customer.whatsapp),
                zipcode: customer.zipcode && formatCep(customer.zipcode),
                number: customer.number,
                complement: customer.complement,
                email: customer.email
            })
        }

    }, [customer]);

    function formatCep(cep) {
        if (!cep) return '';
        return cep.replace(/\D/g, '').replace(/^(\d{5})(\d{3})$/, '$1-$2');
    }

    useEffect(() => {
        if (zipcode && zipcode.length === 9) {
            const searchAddressByZipcode = async () => {
                try {
                    setDisabledInputZipcode(true)
                    const response = await axios.get(`https://viacep.com.br/ws/${zipcode}/json`);
                    const data = response.data;
                    if (response.data.erro) {
                        setAddress(null)
                    } else {
                        const address = {
                            street: data.logradouro,
                            district: data.bairro,
                            state: data.uf,
                            city: data.localidade
                        }
                        setAddress(address)
                    }
                    setDisabledInputZipcode(false)
                } catch (error) {
                    setDisabledInputZipcode(false)
                    console.error('Erro ao buscar dados do CEP:', error);
                }
            };

            searchAddressByZipcode();
        }
    }, [zipcode]);

    const createOrUpdate = async (values, { setErrors, resetForm }) => {

        const data = {
            ...values,
            ...address,
            number: values.number,
            zipcode: values?.zipcode?.replaceAll('-', '')
        }

        const cleanedData = Object.fromEntries(
            Object.entries(data).map(([key, value]) =>
                value === '' ? [key, null] : [key, value]
            )
        );

        setIsLoading(true)
        service.create(cleanedData)
            .then(async (_) => {
                HallAppToast.success();
                if (call) {
                    call()
                }

                if (!customer || Object.keys(customer).length === 0) {
                    resetForm()
                }
            }).catch((_) => {
                HallAppToast.error();
            }).finally((_) => setIsLoading(false))

    }

    const whatsMask = useMask({ mask: '(__)_____-____', replacement: { _: /\d/ } })
    const dateMask = useMask({ mask: '__/__/____', replacement: { _: /\d/ } })
    const zipcodeMask = useMask({ mask: '_____-___', replacement: { _: /\d/ } })

    return (
        <>
            <Modal className='hallapp-establishment-modal' show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header className='hallapp-establishment-modal custom-close-button' closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        ADICIONAR CLIENTE
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AppContainer>
                        <Formik
                            validationSchema={schema}
                            onSubmit={createOrUpdate}
                            enableReinitialize={true}
                            initialValues={initialValues}
                        >
                            {({ handleSubmit, handleChange, setFieldValue, values, touched, errors }) => (
                                <div className='container'>
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <AppInputV2
                                            isRequired
                                            errors={errors}
                                            touched={touched}
                                            name='name'
                                            onChange={handleChange}
                                            value={values.name}
                                            type='text'
                                            label='Nome do(a) cliente' />

                                        <AppInputV2
                                            isRequired
                                            errors={errors}
                                            touched={touched}
                                            name='whatsapp'
                                            onChange={handleChange}
                                            value={values.whatsapp}
                                            mask={whatsMask}
                                            type='text'
                                            disabled={customer && Object.keys(customer).length > 0}
                                            label='Whatsapp' />

                                        <AppInputV2
                                            errors={errors}
                                            touched={touched}
                                            name='email'
                                            onChange={handleChange}
                                            value={values.email}
                                            type='text'
                                            label='E-mail' />

                                        <AppInputV2
                                            errors={errors}
                                            touched={touched}
                                            name='birthday'
                                            onChange={handleChange}
                                            mask={dateMask}
                                            value={values.birthday}
                                            formText='DD/MM/YYYY'
                                            type='text'
                                            label='Data de Nascimento' />

                                        <AppInput
                                            errors={errors}
                                            touched={touched}
                                            name='zipcode'
                                            onChange={(e) => {
                                                setFieldValue('zipcode', e.target.value);
                                                setZipcode(e.target.value);
                                            }}
                                            value={values.zipcode}
                                            type='text'
                                            label='CEP'
                                            disabled={disabledInputZipcode}
                                            mask={zipcodeMask} />

                                        <AppInputV2
                                            errors={errors}
                                            touched={touched}
                                            name='number'
                                            onChange={handleChange}
                                            value={values.number}
                                            type='text'
                                            label='Número' />

                                        <AppInputV2
                                            errors={errors}
                                            touched={touched}
                                            name='complement'
                                            onChange={handleChange}
                                            value={values.complement}
                                            type='text'
                                            label='Complemento' />

                                        <hr></hr>

                                        <div style={{ marginBottom: '20px' }}>
                                            <CustomCard>
                                                <p><span style={{ fontWeight: 'bold' }}>Rua: </span> {address?.street || '--'}</p>
                                                <p><span style={{ fontWeight: 'bold' }}>Bairro: </span> {address?.district || '--'}</p>
                                                <p><span style={{ fontWeight: 'bold' }}>Cidade/Estado: </span>{address?.city} - {address?.state}</p>
                                            </CustomCard>
                                        </div>


                                        {isLoading ? <div style={{ textAlign: 'center' }}>
                                            <AppLoading />
                                        </div> :
                                            <>
                                                <AppButton type="submit" width='100%' name='salvar' />
                                                <div style={{ marginTop: '10px', width: '100%' }}>
                                                    <AppLinkButton fullWidth='true' name='CANCELAR' onClick={closeShow} />
                                                </div>
                                            </>
                                        }

                                    </Form>
                                </div>
                            )}
                        </Formik>
                    </AppContainer>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddManualCustomerModal;